export default __webpack_public_path__ + "6acef8a9ff34913329c6ad1b77d4746d.svg";